module.exports = __webpack_public_path__ + "static/0c3bc469-ac9f-4c9a-a72f-e27f86ffa8fe-7470d7938619c1485d696f58f6c38ea9.webp";